var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Layout", [
    _c("div", { staticClass: "ep__main_content pt-80" }, [
      _c("section", { staticClass: "content pt-40 pb-40" }, [
        _c("div", {
          staticClass: "container page p-0",
          domProps: { innerHTML: _vm._s(_vm.termOfUseContent) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }